export const titleFeatureKey = 'title';
export type Title = {
    id: number;
    name: string;
    abbreviation: string;
}

